import { createApp } from 'vue';
import axios from 'axios';
import CalculatorComponent from './components/CalculatorComponent.vue';

const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

if (csrfToken) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
}

const calculatorRoot = document.querySelector('[data-calculator-app]');

if (calculatorRoot) {
    const propsElement = document.querySelector('#calculator-props');
    const props = propsElement ? JSON.parse(propsElement.textContent) : {};
    const app = createApp(CalculatorComponent, props);

    app.config.globalProperties.$http = axios;
    app.mount(calculatorRoot);
}
